import { roles, statusPrestationsValues, subRoles } from "../utils/constants";
import React from "react";
import { InterpretesList } from "../pages/Interpretes/InterpretesList/InterpretesList";
import { InstitutionDetail } from "../pages/Institutions/InstitutionDetail/InstitutionDetail";
import { PrestationsList } from "../pages/Prestations/PrestationsList/Prestations.list";
import { Login } from "../pages/Auth/login/Login";
import PublicRegister from "../pages/Auth/PublicRegister/PublicRegister";
import { PasswordLost } from "../pages/Auth/PasswordLost/PasswordLost";
import { PasswordReset } from "../pages/Auth/PasswordReset/PasswordReset";
import { DefaultRouteRole } from "./AuthRoute";
import MainLayout from "../layouts/MainLayout";
import { PrestationDetail } from "../pages/Prestations/PrestationDetail/Prestation.detail";
import { PrestationInformations } from "../pages/Prestations/PrestationInformations/PrestationInformations";
import { PrestationBilling } from "../pages/Prestations/PrestationBilling/PrestationBilling";
import { PrestationInterpretes } from "../pages/Prestations/PrestationInterpretes/Prestation.interpretes";
import { PrestationResume } from "../pages/Prestations/PrestationResume/PrestationResume";
import { InstitutionUsers } from "../pages/Institutions/InstitutionUsers/Institution.users";
import { InstitutionsList } from "../pages/Institutions/InstitutionsList/Institutions.list";
import { InstitutionUser } from "../pages/Institutions/InstitutionUser/Institution.user";
import {
  BillingCrumb,
  BreadcrumbsLink,
  InstitutionCrumb,
  InstitutionUserCrumb,
  InterpretesCrumb,
  PrestationCrumb,
  PrincipalCrumb,
  UsersCrumb,
} from "../shared/components/Breadcrumbs/Breadcrumbs";
import { InterpreteSchedule } from "../pages/Interpretes/InterpreteSchedule/InterpreteSchedule";
import { InterpreteDetail } from "../pages/Interpretes/InterpreteDetail/InterpreteDetail";
import { PrincipalDetail } from "../pages/Principals/PrincipalDetail/PrincipalDetail";
import { PrincipalUsers } from "../pages/Principals/PrincipalUsers/PrincipalUsers";
import { PrincipalUser } from "../pages/Principals/PrincipalUser/PrincipalUser";
import { Principalslist } from "../pages/Principals/PrincipalsList/Principalslist";
import { PrincipalInstitutions } from "../pages/Principals/PrincipalInstitutions/PrincipalInstitutions";
import { InstitutionAddresses } from "../pages/Institutions/InstitutionAddresses/InstitutionAddresses";
import { PrestationAnswerYes } from "../pages/Prestations/PrestationAnswerYes/PrestationAnswerYes";
import { PrincipalAddresses } from "../pages/Principals/PrincipalAddresses/PrincipalAddresses";
import { LogDetail } from "../pages/Logs/LogDetail/LogDetail";
import { LogsList } from "../pages/Logs/LogsList/Logs.list";
import { BillDetail } from "../pages/Billing/BillDetail/BillDetail";
import { BillEdit } from "../pages/Billing/BillEdit/BillEdit";
import { BillingList } from "../pages/Billing/BillingList/BillingList";
import { InstitutionLocations } from "../pages/Institutions/InstitutionLocations/InstitutionLocations";
import { UsersList } from "../pages/Users/UsersList/users.list";
import { UserDetail } from "../pages/Users/userDetail/user.detail";
import { InstitutionResponsables } from "../pages/Institutions/InstitutionResponsables/InstitutionResponsables";
import { PrestationSelector } from "../pages/Prestations/PrestationSelector/Prestation.selector";
import { InstitutionMerge } from "../pages/Institutions/InstitutionMerge/InstitutionMerge";
import { MergeHistoryList } from "../pages/Institutions/InstitutionMerge/History/MergeHistory.list";
import { MergeDetail } from "../pages/Institutions/InstitutionMerge/History/MergeDetail";

const routes = {
  root: () => {
    const path = "/";
    const title = "Accueil";

    return {
      path,
      title,
      index: {
        path,
        title,
        element: <MainLayout />,
        all: 1,
      },
      main: {
        path,
        index: true,
        element: <DefaultRouteRole />,
        title,
        all: 1,
      },
    };
  },
  prestations: (_id = ":id") => {
    const path = "prestations";
    const title = "Prestations";

    const {
      draft,
      planned,
      finish,
      cancel,
      cancelAvic,
      cancelInterprete,
      cancelClient,
      waiting,
      finish_permanance,
      finish_notsigned,
    } = statusPrestationsValues;

    const ressourceCrumbs = () => {
      return <BreadcrumbsLink to={path} title={title} />;
    };

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <PrestationCrumb route={route} />,
      title,
      path,
      new: {
        path: `/${path}/new`,
        title: "Nouvelle prestation",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
          [subRoles.institutionAdmin]: "crud",
          [subRoles.institutionDemander]: "crud",
        },
      },
      selector: {
        path: `/${path}/${_id}/selector`,
        element: <PrestationSelector />,
        title: "Création par interprète",
        visibility: { status: [draft], edit: false },
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
          [subRoles.institutionAdmin]: "crud",
          [subRoles.institutionDemander]: "crud",
        },
        fallBack: params => {
          return `/${path}/${params}`;
        },
      },
      detail: {
        element: <PrestationDetail />,
        path: `/${path}/${_id}`,
        title: "1. Détails",
        visibility: { status: [draft], edit: true },
        fallBack: params => {
          if (params === "new") {
            return `/`;
          }

          return `/${path}/${params}/resume`;
        },
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          [subRoles.institutionDemander]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
        },
      },
      detailInterpretes: {
        fallBack: params => `/${path}/${params}`,
        visibility: { status: [draft, waiting], edit: true },
        disabled: { step: "searchInterpretes" },
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
          [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          [subRoles.institutionDemander]: "crud", // Create Read Update Delete
        },
        path: `/${path}/${_id}/interpretes`,
        title: ({ status, dangerousUpdate }) => {
          return status === statusPrestationsValues.draft || dangerousUpdate
            ? "2. Interprètes"
            : "Interprètes";
        },
        element: <PrestationInterpretes />,
      },
      detailResume: {
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "cr", // Create Read Update Delete
          [subRoles.institutionDemander]: "cr", // Create Read Update Delete
          [roles.permanance]: "crud",
          [roles.interprete]: "r",
        },
        fallBack: params => {
          if (params === "new") {
            return `/`;
          }

          return `/${path}/${params}`;
        },
        disabled: { step: "resume" },
        path: `/${path}/${_id}/resume`,
        title: ({ status, dangerousUpdate }) => {
          return status === statusPrestationsValues.draft || dangerousUpdate
            ? "4. Récapitulatif"
            : "Détails";
        },
        element: <PrestationResume />,
      },
      detailInformations: {
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          [subRoles.institutionDemander]: "r", // Create Read Update Delete
          [roles.permanance]: "crud",
        },
        element: <PrestationInformations />,
        disabledOnNew: true,
        visibility: { status: [draft], edit: true },
        disabled: { step: "complements" },
        fallBack: params => `/${path}/${params}`,
        path: `/${path}/${_id}/informations`,
        title: "3. Compléments ",
      },
      confirmAnswerYes: {
        path: `/${path}/${_id}/success`,
        element: <PrestationAnswerYes />,
        all: 1,
      },
      detailBilling: {
        visibility: {
          status: [
            finish,
            planned,
            cancelClient,
            cancelAvic,
            cancel,
            finish_permanance,
            finish_notsigned,
          ],
          edit: true,
        },
        element: <PrestationBilling />,
        step: "facturation",
        path: `/${path}/${_id}/billing`,
        title: "Facturation de la commande",
        fallBack: params => `/${path}/${params}`,
        only: {
          // [subRoles.institutionFinance]: "r", // Create Read Update Delete
          // [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
        },
      },
      list: {
        index: true,
        // Title of link
        title: "Prestations",
        // Path being used
        path: `/${path}`,
        element: <PrestationsList />,
        crumb: ressourceCrumbs,

        // Rules should be all OR only. Not both

        // Only level access 2 or more can access it
        // All defined a direct easy full access depending the level of the user
        // all: 1,

        // Specific roles can access to the ressource
        //  only: [roles.institutionAdmin], // Specific
        only: {
          [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          [subRoles.institutionIntervenant]: "r", // Create Read Update Delete
          [subRoles.institutionDemander]: "r", // Create Read Update Delete
          [roles.interprete]: "r", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
    };
  },
  interpretes: (_id = ":id") => {
    const path = "interpretes";
    const title = "Interprètes";

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <InterpretesCrumb route={route} />,
      path,
      detail: {
        element: <InterpreteDetail />,
        path: `/${path}/${_id}`,
        title: "Détails de l'interprète",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.interprete]: "crud", // Create Read Update Delete
        },
      },
      detailSchedule: {
        all: 1,
        disabled: { onNew: true },
        element: <InterpreteSchedule />,
        path: `/${path}/${_id}/schedules`,
        title: "Disponibilités ",
      },
      myAccount: {
        path: `/${path}/${_id}`,
        title: "Mon compte",
        only: {
          [roles.interprete]: "crud", // Create Read Update Delete
        },
      },
      list: {
        crumb: route => <BreadcrumbsLink to={`/${path}`} title={title} />,
        element: <InterpretesList />,
        title: "Interprètes",
        path: `/${path}`,
        all: 4,
      },
      new: { path: `/${path}/new`, title: "Nouvel interprète", all: 1 },
    };
  },
  users: (_id = ":id") => {
    const path = "users";
    const title = "Utilisateurs";

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <UsersCrumb route={route} />,
      path,
      detail: {
        element: <UserDetail />,
        path: `/${path}/${_id}`,
        title: "Détails de l'utilisateur",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
      },

      list: {
        crumb: route => <BreadcrumbsLink to={`/${path}`} title={title} />,
        element: <UsersList />,
        title: "Utilisateurs",
        path: `/${path}`,
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
      new: {
        path: `/${path}/new`,
        title: "Nouvel utilisateur",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
    };
  },
  billing: (_id = ":id") => {
    const path = "billing";
    const title = "Facturation";

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <BillingCrumb route={route} />,
      path,
      detail: {
        element: <BillDetail />,
        path: `/${path}/${_id}`,
        title: "Détails de la facture",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.institution]: "r", // Create Read Update Delete
          // [subRoles.institutionFinance]: "crud", // Create Read Update Delete
          // [roles.mandant]: "crud", // Create Read Update Delete
        },
      },
      edition: {
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          [subRoles.institutionFinance]: "r", // Create Read Update Delete
        },
        disabled: { onNew: true },
        element: <BillEdit />,
        path: `/${path}/${_id}/edit`,
        title: "Edition de la facture ",
      },
      list: {
        crumb: route => <BreadcrumbsLink to={`/${path}`} title={title} />,
        element: <BillingList />,
        title: "Facturation",
        path: `/${path}`,
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          // [subRoles.institutionFinance]: "crud", // Create Read Update Delete
          // [roles.mandant]: "crud", // Create Read Update Delete
        },
      },
    };
  },
  institutions: (_id = ":id") => {
    const path = "institutions";
    const title = "Institutions";

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <InstitutionCrumb route={route} />,
      title,
      path,
      detail: {
        element: <InstitutionDetail />,
        path: `/${path}/${_id}`,
        title: "Détails de l'institution",
        only: {
          [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          [subRoles.institutionFinance]: "r", // Create Read Update Delete
          [subRoles.institutionDemander]: "r", // Create Read Update Delete
        },
      },
      myInstitution: {
        element: <InstitutionDetail />,
        path: `/${path}/${_id}`,
        title: "Mon institution",
        only: {
          [roles.institution]: "crud", // Create Read Update Delete
        },
      },
      addresses: {
        disabled: { onNew: true },
        element: <InstitutionAddresses />,
        path: `/${path}/${_id}/addresses`,
        title: "Adresses de facturation",
        only: {
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "r", // Read
          [subRoles.institutionDemander]: "r", // Read
          [subRoles.institutionFinance]: "r", // Read
        },
      },
      locations: {
        disabled: { onNew: true },
        element: <InstitutionLocations />,
        path: `/${path}/${_id}/locations`,
        title: "Lieux d'intervention",
        only: {
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "r", // Read
          [subRoles.institutionDemander]: "r", // Read
        },
      },
      responsables: {
        disabled: { onNew: true },
        element: <InstitutionResponsables />,
        path: `/${path}/${_id}/responsables`,
        title: "Responsables d'entretien",
        only: {
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "r", // Read
          [subRoles.institutionDemander]: "r", // Read
        },
      },
      detailUsers: {
        element: <InstitutionUsers />,
        disabled: { onNew: true },
        path: `/${path}/${_id}/users`,
        title: "Utilisateurs",
        only: {
          [roles.permanance]: "crud",
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.institution]: "r", // Create Read Update Delete
          [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
        },
      },
      newUserInstitution: (user = ":user") => {
        return {
          element: <InstitutionUser isNew={true} />,
          disabled: { onNew: true },
          crumb: route => <InstitutionUserCrumb route={route} />,
          path: `/${path}/${_id}/users/${user}`,
          title: "Nouvel utilisateur",
          only: {
            [roles.permanance]: "crud",
            [roles.admin]: "crud", // Create Read Update Delete
            [roles.institution]: "crud", // Create Read Update Delete
            [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          },
        };
      },
      detailUser: (user = ":user") => {
        return {
          element: <InstitutionUser />,
          disabled: { onNew: true },
          crumb: route => <InstitutionUserCrumb route={route} />,
          path: `/${path}/${_id}/users/${user}`,
          title: "Utilisateur",
          only: {
            [roles.permanance]: "crud",
            [roles.admin]: "crud", // Create Read Update Delete
            [roles.institution]: "r", // Create Read Update Delete
            [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          },
        };
      },

      detailIntervenants: {
        all: 1,
        path: `/${path}/${_id}/intervenants`,
        title: "Intervenants",
      },
      list: {
        element: <InstitutionsList />,
        title: "Institutions",
        path: `/${path}`,
        all: 4,
      },
      merge: {
        element: <InstitutionMerge />,
        title: "Fusion d'institutions",
        path: `/${path}/merge`,
        only: {
          [roles.permanance]: "crud",
          [roles.admin]: "crud",
        },
      },
      mergeHistory: {
        element: <MergeHistoryList />,
        title: "Historique des fusions",
        path: `/${path}/merge/history`,
        only: {
          [roles.permanance]: "crud",
          [roles.admin]: "crud",
        },
      },
      mergeDetail: (mergeId = ":mergeId") => ({
        element: <MergeDetail />,
        title: "Détail de la fusion",
        path: `/${path}/merge/history/${mergeId}`,
        only: {
          [roles.permanance]: "crud",
          [roles.admin]: "crud",
        },
      }),
      new: {
        path: `/${path}/new`,
        title: "Nouvelle institution",
        only: {
          [roles.permanance]: "crud",
          [roles.admin]: "crud", // Create Read Update Delete
        },
      },
    };
  },
  principals: (_id = ":id") => {
    const path = "principals";
    const title = "Mandants globaux";

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <PrincipalCrumb route={route} />,
      title,
      path,
      detail: {
        all: 1,
        element: <PrincipalDetail />,
        path: `/${path}/${_id}`,
        title: "Détails du Mandant",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
      myPrincipal: {
        element: <PrincipalDetail />,
        path: `/${path}/${_id}`,
        title: "Mon compte mandant",
        only: {
          [roles.mandant]: "crud", // Create Read Update Delete
        },
      },
      detailUsers: {
        element: <PrincipalUsers />,
        disabled: { onNew: true },
        path: `/${path}/${_id}/users`,
        title: "Utilisateurs",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.mandant]: "crud", // Create Read Update Delete
        },
      },
      addresses: {
        disabled: { onNew: true },
        element: <PrincipalAddresses />,
        path: `/${path}/${_id}/addresses`,
        title: "Adresses de facturation",
        all: 3,
      },

      detailInstitutions: {
        all: 1,
        element: <PrincipalInstitutions />,
        disabled: { onNew: true },
        path: `/${path}/${_id}/institutions`,
        title: "Mandant Institutions",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
      detailUser: (user = ":user") => {
        return {
          element: <PrincipalUser />,
          disabled: { onNew: true },
          // crumb: route => <InstitutionUserCrumb route={route} />,
          path: `/${path}/${_id}/users/${user}`,
          title: "Utilisateur",
          only: {
            [roles.admin]: "crud", // Create Read Update Delete
            [roles.institution]: "crud", // Create Read Update Delete
            [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          },
        };
      },
      list: {
        element: <Principalslist />,
        title: "Mandants",
        path: `/${path}`,
        all: 4,
      },
      new: { path: `/${path}/new`, title: "Nouveau mandant global" },
    };
  },
  user: (_id = ":id") => {
    const path = "user";
    // Utilisateur
    return {
      detail: `/${path}/${_id}?tab=informations`,
      list: `/${path}`,
      new: `/${path}/new`,
    };
  },
  logs: (_id = ":id") => {
    const path = "logs";
    const title = "Logs";

    // log de l'app
    return {
      list: {
        element: <LogsList />,
        path: `/${path}`,
        title: "Logs",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
        },
      },
      detail: {
        element: <LogDetail />,
        path: `/${path}/${_id}`,
        title: "Détail du log",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
        },
      },
    };
  },
  auth: () => {
    const path = "auth";
    // log de l'app
    return {
      path,
      login: {
        element: <Login />,
        index: true,
        path: `/${path}`,
        title: "Login",
        only: {
          [roles.ghost]: "crud", // Create Read Update Delete
        },
      },
      register: {
        element: <PublicRegister />,
        path: `/${path}/register`,
        title: "Register",
        only: {
          [roles.ghost]: "crud", // Create Read Update Delete
        },
      },
      reset: {
        element: <PasswordReset />,
        path: `/${path}/reset`,
        title: "reset",
        only: {
          [roles.ghost]: "crud", // Create Read Update Delete
        },
      },
      lost: {
        element: <PasswordLost />,
        path: `/${path}/lost`,
        title: "lost",
        only: {
          [roles.ghost]: "crud", // Create Read Update Delete
        },
      },
    };
  },
};

export default routes;
